import { PodborkaFindByUrlResponse } from "@project/shared-types";
import { useLoaderData, useLocation } from "react-router";
import { canonicalPath } from "../utils/canonical";
import { Footer } from "../blocks/Footer/Footer";
import { GroupServices } from "../blocks/GroupServices/GroupServices";
import { MenuBottom } from "../blocks/MenuBottom/MenuBottom";
import { UslugiBlock } from "../blocks/uslugi/UslugiBlock";
import { BreadCrumbs } from "../components/BreadCrumbs/BreadCrumbs";
import Header from "../components/header/header";
import { ScrollBlock } from "../components/others/ScrollBlock";
import { UserProvider } from "../context/user/UserContext";
import "../core/core.css";
import { DataProvider } from "../hooks/DataContext";
import { SupportProvider } from "../Support/SupportProvider";

const uslgi = () => {
  const currentPage = useLocation();
  const data = useLoaderData<PodborkaFindByUrlResponse>();
  const is_uslugi = currentPage.pathname.includes("uslugi");
  const breadLinks = [
    { url: "/", name: "Главная" },
    {
      url: currentPage.pathname,
      name: `${is_uslugi ? "Услуги" : "Подборка"}`,
    },
  ];

  return (
    <DataProvider>
      <title>
        {is_uslugi
          ? "Услуги — Купить отзывы для компании HMREP"
          : "Подборка отзывов на заказ для бизнеса"}
      </title>
      <meta
        name="description"
        content={
          is_uslugi
            ? "Отзывы, подписки всё для репутациии вашей организации в интернете"
            : "Подборка услуг по определенным критериям"
        }
      />
      <link
        rel="canonical"
        href={`https://hmrep.ru${canonicalPath(currentPage.pathname)}`}
      />
      <UserProvider>
        <SupportProvider>
          <div className="body">
            <ScrollBlock></ScrollBlock>
            <Header></Header>
            <div className="blocks">
              <BreadCrumbs links={breadLinks}></BreadCrumbs>

              <UslugiBlock
                title={is_uslugi ? "Услуги" : "Подборка"}
              > </UslugiBlock>
              {is_uslugi && <GroupServices limit={100}></GroupServices>}

              <Footer></Footer>
            </div>
            <MenuBottom></MenuBottom>
          </div>
        </SupportProvider>
      </UserProvider>
    </DataProvider>
  );
};

export default uslgi;
